import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Mail,
  Briefcase,
  Shield,
  BarChart3,
  AlertCircle,
  CheckCircle,
  Database,
  Globe,
  Cpu,
  Layers,
} from 'lucide-react';
import { baseUrlWithAuth } from '../../../hooks/remote/apiClient';
import AssignedResourceQuotas from './AssignedResourceQuotas';


const StudentProfile = () => {
  document.title = 'Student Profile - CloudVantage';

  const userSessionData = useSelector((state) => state.user.userSessionData);

  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const sessionProfile = useMemo(() => {
    return (
      userSessionData?.student_profile ||
      userSessionData?.student ||
      userSessionData?.user?.student ||
      userSessionData
    );
  }, [userSessionData]);

  const schoolId =
  userSessionData?.school?.id ||
  userSessionData?.school_id ||
  sessionProfile?.school?.id ||
  sessionProfile?.school_id;

const studentId =
  userSessionData?.student_id ||
  userSessionData?.student?.id ||
  userSessionData?.student_profile?.id;

  useEffect(() => {
    let isMounted = true;

    

// const fetchStudentProfile = async () => {
//   try {
//     setLoading(true);

//     const schoolId =
//       userSessionData?.school_id ||
//       userSessionData?.school ||
//       sessionProfile?.school_id ||
//       sessionProfile?.school;

//     const email = userSessionData?.email?.toLowerCase();

//     if (!schoolId || !email) {
//       throw new Error('Missing school ID or email');
//     }

//     // Get all students in the school
//     const listRes = await baseUrlWithAuth.get(`/school/${schoolId}/students/`);

//     const students =
//       listRes.data?.students ||
//       listRes.data?.data?.students ||
//       listRes.data?.data ||
//       listRes.data?.results ||
//       [];

//     const matchedStudent = students.find(
//       (student) => student.email?.toLowerCase() === email
//     );

//     if (!matchedStudent?.id) {
//       throw new Error('Logged-in student not found in student list');
//     }

//     console.log('MATCHED STUDENT:', matchedStudent);

//     // Fetch full profile with real student id
//     const profileRes = await baseUrlWithAuth.get(
//       `/school/${schoolId}/students/${matchedStudent.id}/`
//     );

//     console.log('FULL STUDENT PROFILE RESPONSE:', profileRes.data);

//     setProfileData(profileRes.data);
//     setError(null);
//   } catch (err) {
//     console.error('Student profile error:', err);
//     setProfileData(sessionProfile);
//     setError('Could not load full student profile.');
//   } finally {
//     setLoading(false);
//   }
// };

const fetchStudentProfile = async () => {
  try {
    setLoading(true);

    const schoolId =
  userSessionData?.school?.id ||
  sessionProfile?.school?.id ||
  userSessionData?.school_id ||
  sessionProfile?.school_id;

    const studentId =
  userSessionData?.school?.student_id ||
  sessionProfile?.school?.student_id ||
  userSessionData?.student_id ||
  sessionProfile?.student_id;

    console.log('SCHOOL ID:', schoolId);
    console.log('STUDENT ID:', studentId);
    

    if (!schoolId || !studentId) {
      throw new Error('Missing school ID or student ID');
    }

    const profileRes = await baseUrlWithAuth.get(
      `/school/${schoolId}/students/${studentId}/`
    );

    console.log('FULL PROFILE:', profileRes.data);

    setProfileData(profileRes.data?.data || profileRes.data);
    setError(null);
  } catch (err) {
    console.error('Student profile error:', err);
    setProfileData(sessionProfile);
    setError('Could not load full student profile.');
  } finally {
    setLoading(false);
  }
};

    fetchStudentProfile();

    return () => {
      isMounted = false;
    };
  }, [schoolId, studentId, sessionProfile]);

  const fullName =
    profileData?.name ||
    profileData?.fullname ||
    profileData?.full_name ||
    `${profileData?.firstname || ''} ${profileData?.lastname || ''}`.trim() ||
    userSessionData?.fullname ||
    'Student User';

  const email =
    profileData?.email ||
    profileData?.user?.email ||
    userSessionData?.email ||
    userSessionData?.user?.email ||
    'N/A';

const rawDepartment =
  profileData?.school?.student_department ||
  profileData?.student_department ||
  userSessionData?.school?.student_department ||
  '';

const department = rawDepartment
  ? rawDepartment.split(':::')[0]
  : 'N/A';

  const schoolName =
    profileData?.school?.name ||
    profileData?.school_name ||
    userSessionData?.school?.name;

  const status = profileData?.status || 'Active';

  const initials = fullName
    ?.split(' ')
    ?.filter(Boolean)
    ?.slice(0, 2)
    ?.map((name) => name[0])
    ?.join('')
    ?.toUpperCase();

  // const quotaSource = useMemo(() => {
  //   return (
  //     profileData?.resource_usage ||
  //     profileData?.resource_quota ||
  //     profileData?.quota ||
  //     profileData?.quotas ||
  //     profileData?.usage_template ||
  //     profileData?.template ||
  //     profileData?.student_template ||
  //     profileData?.resource_template ||
  //     profileData?.assigned_template ||
  //     {}
  //   );
  // }, [profileData]);

  const quotaSource =
  profileData?.resource_usage ||
  profileData?.resource_quota ||
  {};

  

  const parsePermissions = () => {
   const rawPermissions = profileData?.permissions || [];

 const quotaSource = profileData?.resource_usage || {};

    if (!rawPermissions) return [];

    if (typeof rawPermissions === 'string') {
      try {
        const parsed = JSON.parse(rawPermissions);

        if (Array.isArray(parsed)) return parsed;

        if (typeof parsed === 'object') {
          return Object.entries(parsed).map(([key, value]) => ({
            permission: key,
            granted: !!value,
          }));
        }
      } catch {
        return rawPermissions
          .split(',')
          .filter(Boolean)
          .map((item) => ({
            permission: item.trim(),
            granted: true,
          }));
      }
    }

    if (Array.isArray(rawPermissions)) return rawPermissions;

    if (typeof rawPermissions === 'object') {
      return Object.entries(rawPermissions).map(([key, value]) => ({
        permission: key,
        granted: !!value,
      }));
    }

    return [];
  };

  const parsedPermissions = parsePermissions();

  const quotaItems = [
    {
      label: 'Virtual Servers (Dews)',
      used:
        quotaSource?.servers_used ??
        quotaSource?.used_servers ??
        quotaSource?.dews_used ??
        quotaSource?.instances_used ??
        0,
      limit:
        quotaSource?.servers_limit ??
        quotaSource?.max_servers ??
        quotaSource?.dews_limit ??
        quotaSource?.instances_limit ??
        0,
      icon: <Cpu className="w-4 h-4 text-indigo-500" />,
      colorClass: 'bg-indigo-500',
    },
    {
      label: 'Volumes',
      used: quotaSource?.volumes_used ?? quotaSource?.used_volumes ?? 0,
      limit: quotaSource?.volumes_limit ?? quotaSource?.max_volumes ?? 0,
      icon: <Database className="w-4 h-4 text-emerald-500" />,
      colorClass: 'bg-emerald-500',
    },
    {
      label: 'Private Networks',
      used: quotaSource?.networks_used ?? quotaSource?.used_networks ?? 0,
      limit: quotaSource?.networks_limit ?? quotaSource?.max_networks ?? 0,
      icon: <Globe className="w-4 h-4 text-blue-500" />,
      colorClass: 'bg-blue-500',
    },
    {
      label: 'Load Balancers',
      used:
        quotaSource?.load_balancers_used ??
        quotaSource?.used_load_balancers ??
        0,
      limit:
        quotaSource?.load_balancers_limit ??
        quotaSource?.max_load_balancers ??
        0,
      icon: <Layers className="w-4 h-4 text-amber-500" />,
      colorClass: 'bg-amber-500',
    },
    {
      label: 'Storage Space',
      used:
        quotaSource?.storage_used_gb ??
        quotaSource?.used_storage_gb ??
        quotaSource?.storage_used ??
        0,
      limit:
        quotaSource?.storage_limit_gb ??
        quotaSource?.max_storage_gb ??
        quotaSource?.storage_limit ??
        0,
      unit: 'GB',
      icon: <Database className="w-4 h-4 text-rose-500" />,
      colorClass: 'bg-rose-500',
    },
    {
      label: 'Server Snapshots',
      used:
        quotaSource?.server_snapshots_used ??
        quotaSource?.used_server_snapshots ??
        0,
      limit:
        quotaSource?.server_snapshots_limit ??
        quotaSource?.max_server_snapshots ??
        0,
      icon: <Cpu className="w-4 h-4 text-violet-500" />,
      colorClass: 'bg-violet-500',
    },
    {
      label: 'Volume Snapshots',
      used:
        quotaSource?.volume_snapshots_used ??
        quotaSource?.used_volume_snapshots ??
        0,
      limit:
        quotaSource?.volume_snapshots_limit ??
        quotaSource?.max_volume_snapshots ??
        0,
      icon: <Database className="w-4 h-4 text-teal-500" />,
      colorClass: 'bg-teal-500',
    },
    {
      label: 'Database Instances',
      used:
        quotaSource?.db_instances_used ??
        quotaSource?.database_instances_used ??
        quotaSource?.used_databases ??
        0,
      limit:
        quotaSource?.db_instances_limit ??
        quotaSource?.database_instances_limit ??
        quotaSource?.max_databases ??
        0,
      icon: <Database className="w-4 h-4 text-cyan-500" />,
      colorClass: 'bg-cyan-500',
    },
  ];

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[60vh] gap-3">
        <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-primaryBlue"></div>
        <p className="text-sm text-gray-500 dark:text-gray-400">
          Loading student profile...
        </p>
      </div>
    );
  }

  return (
    <div className="px-4 md:px-10 py-6 min-h-screen dark:text-white">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-8 gap-4">
        <div>
          <h1 className="crimson-font text-2xl font-bold text-[#0a1b33] dark:text-white">
            Student Profile
          </h1>
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
            View your cloud credentials, platform privileges, and resource utilization.
          </p>
        </div>

        {schoolName && (
          <div className="bg-[#EEF5FF] dark:bg-[#1e293b] border border-primaryBlue/20 px-4 py-2 rounded-xl text-xs font-semibold text-primaryBlue flex items-center gap-2 w-fit">
            <span className="h-2 w-2 rounded-full bg-primaryBlue animate-pulse"></span>
            {schoolName}
          </div>
        )}
      </div>

      {error && (
        <div className="mb-6 bg-amber-500/10 border border-amber-500/20 text-amber-600 rounded-xl p-4 flex gap-3 items-center text-xs">
          <AlertCircle className="w-5 h-5 shrink-0" />
          <span>{error}</span>
        </div>
      )}

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-start">
        <div className="lg:col-span-4 bg-white dark:bg-slate-800 rounded-2xl border dark:border-[#c4c4c416] border-gray-200/80 p-6 shadow-sm">
          <div className="flex flex-col items-center text-center pb-6 border-b dark:border-b-[#c4c4c416] border-gray-100">
            <div className="h-20 w-20 rounded-full bg-gradient-to-br from-primaryBlue to-[#123866] text-white flex items-center justify-center font-bold text-2xl shadow-md mb-4 uppercase">
              {initials || 'ST'}
            </div>

            <h2 className="text-lg font-bold text-gray-800 dark:text-white capitalize">
              {fullName}
            </h2>

            <span className="mt-1.5 text-xs font-semibold uppercase tracking-wider text-emerald-600 bg-emerald-500/10 border border-emerald-500/20 px-2.5 py-0.5 rounded-full">
              {status}
            </span>
          </div>

          <div className="pt-6 space-y-4">
            <div className="flex items-start gap-3.5">
              <div className="bg-primaryBlue/10 dark:bg-primaryBlue/20 p-2.5 rounded-xl">
                <Mail className="w-4 h-4 text-primaryBlue" />
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-[10px] font-bold uppercase tracking-wider text-gray-400 dark:text-gray-500">
                  Email Address
                </p>
                <p className="text-sm font-medium text-gray-700 dark:text-gray-300 truncate mt-0.5">
                  {email}
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3.5">
              <div className="bg-primaryBlue/10 dark:bg-primaryBlue/20 p-2.5 rounded-xl">
                <Briefcase className="w-4 h-4 text-primaryBlue" />
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-[10px] font-bold uppercase tracking-wider text-gray-400 dark:text-gray-500">
                  Department / Class
                </p>
                <p className="text-sm font-medium text-gray-700 dark:text-gray-300 mt-0.5">
                  {department}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-8 grid gap-6">
          <div className="bg-white dark:bg-slate-800 rounded-2xl border dark:border-[#c4c4c416] border-gray-200/80 p-6 shadow-sm">
            <h3 className="text-sm font-bold text-gray-800 dark:text-white flex items-center gap-2 mb-4">
              <Shield className="w-4 h-4 text-primaryBlue" />
              Platform Permissions
            </h3>

            <p className="text-xs text-gray-500 dark:text-gray-400 mb-6">
              These are the system permissions granted to your account by your school administrator.
            </p>

            {parsedPermissions.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                {parsedPermissions.map((permission, index) => {
                  const name =
                    typeof permission === 'object'
                      ? permission.permission || permission.name || permission.label
                      : permission;

                  const isGranted =
                    typeof permission === 'object'
                      ? permission.granted !== false
                      : true;

                  return (
                    <div
                      key={index}
                      className="flex items-center gap-3 p-3.5 bg-gray-50 dark:bg-[#1a2436] rounded-xl border dark:border-white/5 border-gray-100"
                    >
                      <CheckCircle
                        className={`w-4 h-4 ${
                          isGranted ? 'text-emerald-500' : 'text-gray-400'
                        }`}
                      />
                      <span className="text-xs font-semibold text-gray-700 dark:text-gray-300">
                        {String(name || '').replace(/_/g, ' ')}
                      </span>
                    </div>
                  );
                })}
              </div>
            ) : (
              <p className="text-xs text-gray-400">No permissions assigned.</p>
            )}
          </div>

          <AssignedResourceQuotas profileData={profileData} />
        </div>
      </div>
    </div>
  );
};

export default StudentProfile;